module.exports = __webpack_public_path__ + "media/images/default/pages/about/upload-1b8621b2f285fd44c622ffcc8d03dc29.svg";